module.exports = __webpack_public_path__ + "img/eye-mature-complete.3c2c752f.jpg";